import { render } from "./RadioRating.vue?vue&type=template&id=40369a28&scoped=true&ts=true"
import script from "./RadioRating.vue?vue&type=script&lang=ts"
export * from "./RadioRating.vue?vue&type=script&lang=ts"

import "./RadioRating.vue?vue&type=style&index=0&id=40369a28&lang=scss&scoped=true"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40369a28"]])

export default __exports__